<script>
import debounce from 'debounce'
export default {
  name: 'OrganizationList',
  delimiters: ['${', '}'],
  template: '#organization-list-app',
  props: ['lang', 'year'],
  data() {
    return {
      results: [],
      errors: false,
      sortby: 'alphabetic',
      loading: false,
      page: 1,
      total: 0,
      querySearch: ''
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    sortBy (sort) {
      this.sortby = sort
      this.load()
    },
    cancelSearch() {
      this.querySearch = '';
      this.load()
    },
    load (append) {
      append = append || false
      this.page = (append) ? this.page + 1 : 1
      this.loading = true
      this.errors = false
      axios.get(`/${this.lang}/budget/api/organization`, {
        params: {
          year: this.year,
          sortby: this.sortby,
          page: this.page,
          q: this.querySearch
        }
      }).then(response => {
        let results = response.data.results
        if (!append) {
          this.results = results
        } else {
          this.results = this.results.concat(response.data.results)
        }
        this.total = response.data.count
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        this.errors = true
      })
    },
    getResult: debounce(function () {
      this.load()
    }, 500)
  },
  watch: {
    querySearch: function () {
      this.getResult()
    }
  }
}
</script>
<style scoped>
  [v-cloak] {display: none}
</style>
